import { FormItemLabel } from "@portal/components/form";
import { FormAddressAutocomplete, FormInput } from "@portal/components/form/fields";
import { type FC, useEffect } from "react";
import type { FieldError } from "react-hook-form";
import { useFormContext } from "react-hook-form";
import { useAddressValidation } from "../../../../../../api";
import type { AdminCombinedFormData } from "../../schema";
import { QuickSubmitFormItemGroup } from "../QuickSubmitFormItemGroup";

type CompanySectionProps = {
	onCompanyNameBlur: () => void;
};

export const CompanySection: FC<CompanySectionProps> = ({ onCompanyNameBlur }) => {
	const { control, watch, setValue, setError, clearErrors, formState } =
		useFormContext<AdminCombinedFormData>();

	useEffect(() => {
		setValue("account.details.companies.0.isPrimaryCompany", true);
	}, [setValue]);

	const { addressFieldControl } = useAddressValidation({
		value: watch("account.details.companies.0.address"),
		error: formState.errors?.account?.details?.companies?.[0]?.address as FieldError | undefined,
		setValue: (value: string) => setValue("account.details.companies.0.address", value),
		setError: (error) => setError("account.details.companies.0.address", error),
		clearError: () => clearErrors("account.details.companies.0.address"),
	});

	return (
		<>
			<QuickSubmitFormItemGroup>
				<FormItemLabel name="account.details.companies.0.name">Primary Company Name</FormItemLabel>
				<FormInput
					name={"account.details.companies.0.name"}
					control={control}
					compact
					onBlur={onCompanyNameBlur}
					testId="primary-company-name-input"
				/>
			</QuickSubmitFormItemGroup>
			<QuickSubmitFormItemGroup className="col-span-2">
				<FormItemLabel name="account.details.companies.0.address">
					Primary Company Address
				</FormItemLabel>
				<FormAddressAutocomplete control={addressFieldControl} anchor="bottom start" compact />
			</QuickSubmitFormItemGroup>
		</>
	);
};
